// extracted by mini-css-extract-plugin
export var container = "_fy-0";
export var dotAnimation = "_fy-2";
export var dotsLoading = "_fy-1";